(function () {
    'use strict';

    wo$(() => {
        var searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        var criteria;
        var data;

        var searchResultsController = {
            init: function () {
                criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                data = WhistleOut.readLookupData(searchResultsPage.find('#searchResultsData'));
                var currentTab = searchResultsController.getCurrentTab();
                this.showcheck5gAvailabilitydiv(currentTab.id);
                WhistleOut.setCoverageCookie(data.coverage);
                searchResultsController.bindTabTooltips();
                WhistleOut.bindCta(searchResultsPage);

                if (criteria.lines.length > 1) {
                    searchResultsController.initMultiLinePagedResults();
                } else {
                    searchResultsController.initSingleLinePagedResults();
                }

                searchResultsPage.off('click');

                searchResultsController.initNetworkCoverageSnippet();
                searchResultsController.initPriceActions();

                searchResultsPage.on('click', '[data-price-type-action]', function () {
                    searchResultsController.priceTypeAction(wo$(this), criteria);
                });

                searchResultsPage.on('click', '[data-show-filter-modal]', function () {
                    var lineNumber = wo$(this).data('line');
                    if (!lineNumber || lineNumber < 1) {
                        lineNumber = 1;
                    }
                    WhistleOut.notifications.fire('EditLine', { line: lineNumber });
                });

                searchResultsPage.on('click', '[data-mobile-coverage-retry]', function (e) {
                    e.preventDefault();
                    WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                });

                searchResultsPage.on('click', '[data-hide-promoted]', function (e) {
                    e.preventDefault();
                    criteria.includefeatured = false;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'FeaturedResults', criteria: criteria });
                });

                searchResultsPage.on('click', '[data-show-only-carrier]', function () {
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    var shortUrl = wo$(this).data('show-only-carrier');

                    criteria.suppliers = [shortUrl];
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Suppliers', criteria: criteria });
                });
                searchResultsPage.on('click', '[data-show-all-except-carrier]', function () {
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    var shortUrl = wo$(this).data('show-all-except-carrier');

                    if (criteria.suppliers && criteria.suppliers.length > 0) {
                        criteria.suppliers = criteria.suppliers.filter(function (s) {
                            return s !== shortUrl;
                        });
                    } else {
                        criteria.suppliers = criteria.allSuppliers.filter(function (s) {
                            return s !== shortUrl;
                        });
                    }
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Suppliers', criteria: criteria });
                });
                searchResultsPage.on('click', '[data-show-all-carriers]', function () {
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    criteria.suppliers = null;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Suppliers', criteria: criteria });
                });
                searchResultsPage.on('click', '[data-show-one-result-per-carrier]', function () {
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    criteria.singleResultPerSupplier = true;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Suppliers', criteria: criteria });
                });
                searchResultsPage.on('click', '[data-show-multiple-results-per-carrier]', function () {
                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    criteria.singleResultPerSupplier = false;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Suppliers', criteria: criteria });
                });
                searchResultsPage.on('click', '[data-change-carriers]', function () {
                    WhistleOut.notifications.fire('ChangeCarriers');
                });
                searchResultsPage.on('click', '[data-change-advanced]', function () {
                    WhistleOut.notifications.fire('ChangeAdvanced');
                });

                searchResultsPage.on('click', '[data-tab-button]', function () {
                    var tab = wo$(this).data('tab-button');
                    searchResultsController.switchTabs(tab);
                });

                searchResultsPage.find('[data-tab-link]').click(function (e) {
                    e.preventDefault();
                    var tab = wo$(this).data('tab-link');
                    searchResultsController.switchTabs(tab);
                });

                searchResultsPage.find('[data-tab-linkbutton]').click(function (e) {
                    e.preventDefault();
                    var tab = wo$(this).data('tab-linkbutton');
                    searchResultsController.switchTabs(tab);
                });

                searchResultsPage.on('click', 'a[data-sort-expression]', function () {
                    var sortExpression = wo$(this).data('sort-expression');
                    var sortAscending = true;
                    var isAscending = wo$(this).data('sort-ascending');
                    if (isAscending === false || isAscending === 'False') sortAscending = false;

                    WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                    criteria.sortExpression = sortExpression;
                    criteria.sortAscending = sortAscending;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'Sort', criteria: criteria });
                });

                searchResultsPage.find('[data-comparison-cost-popover]').on('shown.bs.popover', function () {
                    wo$('a[data-popover-sort-expression]').click(function () {
                        searchResultsPage.find('[data-comparison-cost-popover]').popover('hide');
                        var sortExpression = wo$(this).data('popover-sort-expression');
                        var sortAscending = true;
                        var isAscending = wo$(this).data('sort-ascending');
                        if (isAscending === false) sortAscending = false;

                        WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                        criteria.sortExpression = sortExpression;
                        criteria.sortAscending = sortAscending;
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Sort', criteria: criteria });
                    });
                });
                searchResultsPage.on('shown.bs.popover', '[data-closest-match-popover]', function () {
                    wo$('a[data-dont-show-closest-match-button]').click(function () {
                        var line = wo$('a[data-dont-show-closest-match-button]').data('dont-show-closest-match-button');
                        searchResultsPage.find('[data-closest-match-popover]').popover('hide');
                        WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                        if (!line > 0) line = 1;

                        criteria.lines[line - 1].allowPhoneSub = false;
                        WhistleOut.notifications.fire('FilterChanged', {
                            type: 'Phone',
                            criteria: criteria,
                            line: line
                        });
                    });
                });

                searchResultsPage
                    .find('[data-widen-result]')
                    .off('click')
                    .click(function (e) {
                        WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                        e.preventDefault();

                        const id = wo$(this).data('widen-result');
                        const removeAll = id === 'remove-all';

                        const resetMap = {
                            closestPhone: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    if (line.phone) line.allowPhoneSub = false;
                                });
                            },
                            suppliers: () => {
                                criteria.suppliers = [];
                            },
                            networks: () => {
                                criteria.network = [];
                            },
                            upfront: () => {
                                criteria.maxupfront = null;
                            },
                            priceTypes: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    line.phonePriceTypes = criteria.allPriceTypes;
                                    wo$.each(line.phonePriceTypes, (_, priceType) => {
                                        priceType.isChecked = true;
                                    });
                                });
                            },
                            planTypes: () => {
                                criteria.planTypes = null;
                            },
                            calls: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    line.calls = 0;
                                });
                            },
                            minutes: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    line.minutes = 0;
                                });
                            },
                            sms: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    line.sms = 0;
                                });
                            },
                            data: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    line.data = 0;
                                });
                            },
                            unthrottledData: () => {
                                criteria.fullSpeedData = false;
                            },
                            tetherPhone: () => {
                                wo$.each(criteria.lines, (_, line) => {
                                    line.tetherPhone = false;
                                });
                            },
                            deals: () => {
                                criteria.dealsonly = false;
                            },
                            internationalCalls: () => {
                                criteria.includeInternationalCalls = false;
                            },
                            sort: () => {
                                criteria.sortExpression = null;
                                criteria.sortAscending = true;
                            },
                            refurb: () => {
                                criteria.refurbishedPhones = null;
                            },
                            eligibility: () => {
                                criteria.eligibility = null;
                            },
                            roaming: () => {
                                criteria.roaming = false;
                            }
                        };

                        const keysToReset = removeAll ? Object.keys(resetMap) : [id];

                        keysToReset.forEach(key => {
                            const resetFn = resetMap[key];
                            if (typeof resetFn === 'function') resetFn();
                        });
                        WhistleOut.scrollTo(0);
                        WhistleOut.notifications.fire('FilterChanged', { criteria: criteria, type: 'Lines' });
                    });

                searchResultsPage.find('a#add-a-line').click(function () {
                    WhistleOut.notifications.fire('AddLine');
                });

                searchResultsPage.find('a[data-edit-line]').click(function () {
                    if (wo$('div.popover').length === 0) {
                        WhistleOut.notifications.fire('EditLine', { line: wo$(this).data('edit-line') });
                    }
                });

                searchResultsPage.find('a[data-goto-tab]').click(function () {
                    var tab = wo$(this).data('goto-tab');
                    searchResultsController.switchTabs(tab);
                    searchResultsPage.find('button[data-tab-button="' + tab + '"]').tab('show');
                });

                searchResultsPage.find('#pp-sub').click(function () {
                    if (searchResultsPage.find('#pp-sub').is(':checked')) {
                        searchResultsPage.find('[data-include-closest-check]').each(function () {
                            wo$(this).prop('checked', true);
                        });
                    } else {
                        searchResultsPage.find('[data-include-closest-check]').each(function () {
                            wo$(this).prop('checked', false);
                        });
                    }
                });

                searchResultsPage.find('[data-include-closest-check]').click(function () {
                    if (
                        searchResultsPage.find('[data-include-closest-check]:checked').length ===
                        searchResultsPage.find('[data-include-closest-check]').length
                    ) {
                        searchResultsPage.find('#pp-sub').prop('checked', true);
                    } else {
                        searchResultsPage.find('#pp-sub').prop('checked', false);
                    }
                });
                searchResultsPage.on('click', 'a[data-results-action = "HideAllPreviewItems"]', function () {
                    searchResultsPage.find('.results-list div[data-result].bg-pink').hide();
                });
                searchResultsPage.on('click', 'a[data-results-action = "ShowPreviewItemsOnly"]', function () {
                    searchResultsPage.find('.results-list div[data-result].bg-pink').show();
                    searchResultsPage.find('.results-list div[data-result]:not(.bg-pink)').hide();
                });
                searchResultsPage.on('click', 'a[data-results-action = "RemovePreviewHighlighting"]', function () {
                    searchResultsPage.find('.results-list div[data-result].bg-pink').removeClass('bg-pink');
                });
                searchResultsPage.on('click', 'a[data-results-action = "HideAllFeaturedResults"]', function () {
                    criteria.includefeatured = false;
                    WhistleOut.notifications.fire('FilterChanged', { type: 'FeaturedResults', criteria: criteria });
                });
                searchResultsPage.on('click', 'a[data-results-action = "DisableMaximumResultLimits"]', function () {
                    criteria.enforcemaximumresultlimits = false;
                    WhistleOut.notifications.fire('FilterChanged', { criteria: criteria });
                });

                WhistleOut.bindExpressResults();

                searchResultsPage.on('shown.bs.popover', '[data-phone-specs-gallery-popover]', function () {
                    WhistleOut.bindPhoneSpecsModal();
                    WhistleOut.bindPhoneGallery();
                });
            },

            initPriceActions: function () {
                searchResultsPage.on('click', '[data-copy-transact-url]', function () {
                    WhistleOut.copyToClipboard(wo$(this).data('copy-transact-url'));
                });
            },

            initNetworkCoverageSnippet: function () {
                const modal = wo$('#modal-network-coverage');
                wo$('[data-goto-coverage-map]')
                    .off('click')
                    .on('click', e => {
                        const networkId = wo$(e.currentTarget).data('goto-coverage-map');
                        const scrollToMap = () => {
                            searchResultsController.selectNetworkInCoverageMap(networkId);
                            WhistleOut.scrollTo('[data-coverage-maps]');
                        };

                        if (window.getComputedStyle(modal[0]).display === 'none') {
                            // Modal is hidden
                            scrollToMap();
                        } else {
                            // Wait for the for CSS transitions to complete
                            // to prevent the page to jump back up
                            modal.on('hidden.bs.modal', () => {
                                modal.off('hidden.bs.modal');
                                scrollToMap();
                            });
                        }
                    });

                modal
                    .find('#apply-network-change')
                    .off('click')
                    .click(function () {
                        criteria.suppliers = [];
                        criteria.networks = [];
                        modal.find('[data-network-checkbox]:checked').each(function () {
                            var networkId = wo$(this).data('network-checkbox');
                            criteria.networks.push(networkId);
                        });
                        criteria.network = criteria.networks.join(',');

                        modal.modal('hide');
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Suppliers', criteria: criteria });
                    });

                wo$('[data-network-bullet]')
                    .off('click')
                    .click(function () {
                        modal.modal('show');
                    });

                wo$('[data-show-coverage-modal]')
                    .off('click')
                    .click(function () {
                        modal.modal('show');
                    });

                modal.off('show.bs.modal').on('show.bs.modal', function () {
                    wo$.each(data.networks, function (index, network) {
                        var id = network.id;

                        var element = modal.find('[data-network-id="' + id + '"]');
                        element
                            .find('[data-network-checkbox="' + id + '"]')
                            .prop('checked', network.isSelected && (network.has3GCoverage || network.has4GCoverage));
                    });
                });

                if (wo$('#network-coverage-snippet') && wo$('#network-coverage-snippet').length) {
                    if (data.address && data.address != null) {
                        wo$('#network-coverage-snippet').removeClass('hidden');
                    } else {
                        wo$('#network-coverage-snippet').addClass('hidden');
                    }
                }
            },

            selectNetworkInCoverageMap: function (networkId) {
                if (isNaN(networkId) || networkId === '') {
                    return;
                }

                var mobileMapElement = wo$('[data-mobile-map]');
                if (mobileMapElement.length) {
                    var element = mobileMapElement.get(0);
                    var select = wo$(element).parent().parent().find('select[data-mobile-provider]');
                    select.val(networkId);
                    select.selectpicker('refresh');
                    select.trigger('change');
                }
            },

            bindTabTooltips: function () {
                searchResultsPage
                    .find('button[data-tab-button], button[data-tab-buttongroup], button[data-popover-button]')
                    .each(function () {
                        var tab = wo$(this);
                        var content = tab.data('tooltip-text');
                        if (content !== '') {
                            tab.popover({
                                container: 'body',
                                trigger: 'hover',
                                placement: 'top',
                                content: content,
                                html: true
                            });
                        }
                    });
            },

            switchTabs: function (tab) {
                this.showcheck5gAvailabilitydiv(tab);
                var selectedTabLink = searchResultsPage.find('a[data-tab-link=' + tab + ']');
                searchResultsPage.find('a[data-tab-link] > i').addClass('hidden');
                selectedTabLink.find('i').removeClass('hidden');
                selectedTabLink.closest('div').find('button span.dropdownText').text(selectedTabLink.data('text'));
                selectedTabLink.closest('div').find('button span.resultCount').text(selectedTabLink.data('count'));
                selectedTabLink.closest('div').find('button span.subtext').text(selectedTabLink.data('subtext'));

                var selectedTabLinkButton = searchResultsPage.find('a[data-tab-linkbutton=' + tab + ']');
                searchResultsPage.find('a[data-tab-linkbutton] > i').addClass('hidden');
                searchResultsPage
                    .find('a[data-tab-linkbutton]')
                    .closest('div.btn-group')
                    .find('button')
                    .removeClass('active');
                if (selectedTabLinkButton.length > 0) {
                    selectedTabLinkButton.find('i').removeClass('hidden');
                    var button = selectedTabLinkButton.closest('div.btn-group').find('button');
                    button.find('span.dropdownText').text(selectedTabLinkButton.data('text'));
                    button.find('span.resultCount').text(selectedTabLinkButton.data('count'));
                    button.find('span.subtext').text(selectedTabLinkButton.data('subtext'));
                    button.addClass('active');
                    var content = selectedTabLinkButton.data('tooltip-text');
                    var popover = button.data('bs.popover');
                    if (popover) {
                        popover.options.content = content;
                        popover.tip().find('.popover-content').html(content);
                    }
                }
                searchResultsPage.find('button[data-tab-button]').removeClass('active');
                searchResultsPage.find('button[data-tab-button=' + tab + ']').addClass('active');
                searchResultsPage
                    .find('div[data-results-container] div#' + tab)
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
                criteria.tab = tab;
                searchResultsController.toggleLoadMoreButtonVisbility();
                WhistleOut.notifications.fire('TabChanged', { criteria: criteria });
            },

            showcheck5gAvailabilitydiv: function (tab) {
                var divCheck5gAvailability = searchResultsPage.find('div#check5gAvailability');
                if (tab === '5g' || divCheck5gAvailability.is(':visible')) {
                    divCheck5gAvailability.slideToggle();
                }
            },

            priceTypeAction: function (element, criteria) {
                WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                var action = element.data('price-type-action');
                var value = element.data('value');
                var lineNumber = element.data('line');

                switch (action) {
                    case 'prepaid':
                        switch (value) {
                            case 'show':
                                criteria.prepaidExpiry = null;
                                criteria.maximumPrepaidExpiry = null;
                                criteria.tab = 'prepaid';
                                break;
                            case 'hide':
                                criteria.prepaidExpiry = null;
                                criteria.maximumPrepaidExpiry = null;
                                criteria.planTypes = new Array('postpaid');
                                criteria.tab = '';
                                break;
                        }
                        break;

                    case 'show':
                        if (lineNumber > 0) {
                            criteria.lines[lineNumber - 1].phonePriceTypes = [{ value: value }];
                        } else {
                            wo$.each(criteria.lines, function (index, line) {
                                line.phonePriceTypes = [{ value: value }];
                            });
                        }
                        break;

                    case 'showAll':
                        if (lineNumber > 0) {
                            criteria.lines[lineNumber - 1].phonePriceTypes = criteria.allPriceTypes;
                        } else {
                            wo$.each(criteria.lines, function (index, line) {
                                line.phonePriceTypes = criteria.allPriceTypes;
                            });
                        }
                        break;

                    case 'hide':
                        if (lineNumber > 0) {
                            if (
                                criteria.lines[lineNumber - 1].phonePriceTypes &&
                                criteria.lines[lineNumber - 1].phonePriceTypes.length > 0 &&
                                !(
                                    criteria.lines[lineNumber - 1].phonePriceTypes.length === 1 &&
                                    criteria.lines[lineNumber - 1].phonePriceTypes[0].value === value
                                )
                            ) {
                                criteria.lines[lineNumber - 1].phonePriceTypes = criteria.lines[
                                    lineNumber - 1
                                ].phonePriceTypes.filter(function (t) {
                                    return t.value !== value;
                                });
                            } else {
                                criteria.lines[lineNumber - 1].phonePriceTypes = criteria.allPriceTypes.filter(
                                    function (t) {
                                        return t.value !== value;
                                    }
                                );
                            }
                        } else {
                            wo$.each(criteria.lines, function (index, line) {
                                if (
                                    line.phonePriceTypes &&
                                    line.phonePriceTypes.length > 0 &&
                                    !(line.phonePriceTypes.length === 1 && line.phonePriceTypes[0].value === value)
                                ) {
                                    line.phonePriceTypes = line.phonePriceTypes.filter(function (t) {
                                        return t.value !== value;
                                    });
                                } else {
                                    line.phonePriceTypes = criteria.allPriceTypes.filter(function (t) {
                                        return t.value !== value;
                                    });
                                }
                            });
                        }
                        break;
                }

                WhistleOut.notifications.fire('FilterChanged', { type: 'PriceType', criteria: criteria });
            },

            getSortExpression: function () {
                return searchResultsPage.find('*[data-selected-sort-expression]').data('selected-sort-expression');
            },

            getSortAscending: function () {
                var isAscending = searchResultsPage
                    .find('*[data-selected-sort-ascending]')
                    .data('selected-sort-ascending');
                if (isAscending === false || isAscending === 'False') return false;
                return true;
            },

            getCurrentTab: function () {
                const config = WhistleOut.getSiteConfiguration();
                var selectedTab;
                var selectedTabId = criteria.tab || config.mobilePhonesConfig.defaultTab;
                wo$.each(data.tabs, function (index, tab) {
                    if (tab.id === selectedTabId) {
                        selectedTab = tab;
                    }
                });
                if (!selectedTab) {
                    selectedTab = data.tabs[0];
                    criteria.tab = selectedTab.id;
                    WhistleOut.notifications.fire('TabChanged', { criteria: criteria });
                }
                return selectedTab;
            },

            toggleLoadMoreButtonVisbility: function () {
                var currentTab = searchResultsController.getCurrentTab();
                if (currentTab.current >= currentTab.total) {
                    searchResultsPage.find('#load-more').hide();
                } else {
                    searchResultsPage.find('#load-more').show();
                }
            },

            initMultiLinePagedResults: function () {
                var resultContent = searchResultsPage.children(':first');
                var pageSize = resultContent.data('page-size');
                searchResultsController.toggleLoadMoreButtonVisbility();
                searchResultsPage
                    .find('#load-more button')
                    .off('click')
                    .click(function () {
                        var currentTab = searchResultsController.getCurrentTab();
                        var current = currentTab.current;
                        var queryString = WhistleOut.MobilePhones.generateQueryString(criteria);
                        searchResultsPage.find('#load-more button .fa-spinner').show();
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        wo$.ajax({
                            url: criteria.multiLinePagedResultAjaxUrl + '?' + queryString + '&current=' + current,
                            type: 'GET',
                            success: function (result) {
                                var $results = searchResultsPage.find('div.results-list');
                                $results.append(result);
                                currentTab.current = currentTab.current + pageSize;
                                WhistleOut.applyPopover($results);
                                WhistleOut.bindCta($results);
                                searchResultsController.initNetworkCoverageSnippet();
                                searchResultsController.initPriceActions();
                                searchResultsPage.find('#load-more button .fa-spinner').hide();
                                wo$('[data-enable-when-ready]').removeAttr('disabled');
                                searchResultsController.toggleLoadMoreButtonVisbility();
                                WhistleOut.notifications.fire('PagedResultsLoaded');
                            },
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            error: function () {}
                        });
                    });
            },

            initSingleLinePagedResults: function () {
                var resultContent = searchResultsPage.children(':first');
                var pageSize = resultContent.data('page-size');
                searchResultsController.toggleLoadMoreButtonVisbility();
                searchResultsPage
                    .find('#load-more button')
                    .off('click')
                    .click(function () {
                        var currentTab = searchResultsController.getCurrentTab();
                        var current = currentTab.current;
                        var queryString = WhistleOut.MobilePhones.generateQueryString(criteria);
                        searchResultsPage.find('#load-more button .fa-spinner').show();
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        wo$.ajax({
                            url: criteria.singleLinePagedResultAjaxUrl + '?' + queryString + '&current=' + current,
                            type: 'GET',
                            success: function (result) {
                                var $results = wo$('div#' + currentTab.id + ' div.results-list');
                                $results.append(result);
                                currentTab.current = currentTab.current + pageSize;
                                WhistleOut.applyPopover($results);
                                WhistleOut.bindCta($results);
                                searchResultsController.initNetworkCoverageSnippet();
                                searchResultsController.initPriceActions();
                                searchResultsPage.find('#load-more button .fa-spinner').hide();
                                wo$('[data-enable-when-ready]').removeAttr('disabled');
                                searchResultsController.toggleLoadMoreButtonVisbility();
                                WhistleOut.notifications.fire('PagedResultsLoaded');
                            },
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            error: function () {}
                        });
                    });
            }
        };

        searchResultsController.init();
        WhistleOut.notifications.add(function (notification) {
            if (notification === 'SearchResultsRendered') {
                searchResultsController.init();
                wo$(window).resize();
            } else if (notification === 'FiltersModalReady') {
                searchResultsPage.find('[data-enable-when-ready]').removeAttr('disabled');
            }
        });
    });
})();
